// Default values for company limitations
export const COMPANY_DEFAULT_LIMITS = {
  QUESTION: 1000, // questions/month
  TRANSLATION: 2, // docs/month
  STORAGE_GB: 1, // GB (same as upload)
  EXPIRATION_DAYS: 365, // 1 year in days (only used when switching from unlimited to limited)
} as const;

// Helper function to get default expiration date (1 year from now) - only when switching from unlimited to limited
export const getDefaultExpirationDate = (): Date => {
  const date = new Date();
  date.setFullYear(date.getFullYear() + 1);
  return date;
};

// Helper function to format expiration date for display
export const formatExpirationDate = (date: Date): string => {
  return date.toISOString().split('T')[0]; // Format: YYYY-MM-DD
};

// Helper function to get default limitations object
export const getDefaultLimitations = () => ({
  question: COMPANY_DEFAULT_LIMITS.QUESTION,
  translation: COMPANY_DEFAULT_LIMITS.TRANSLATION,
  storage_gb: COMPANY_DEFAULT_LIMITS.STORAGE_GB, // Use storage_gb instead of upload
  expiration: null, // Default is unlimited (null)
});

// Types for company limitations
export interface CompanyLimitations {
  question: number;
  translation: number;
  storage_gb: number; // Use storage_gb instead of upload
  expiration: Date | null; // null means unlimited
}
